<template>
  <div>
    <tabela-lista-produtos />
  </div>
</template>

<script>
import TabelaListaProdutos from "./TabelaListaProdutos";

export default {
  name: "Index",
  components: {TabelaListaProdutos}
}
</script>

<style scoped>

</style>
